import { ADD_EMPLOYEE, DELETE_USER_ROLE, GET_EMPLOYEE, GET_EMPLOYEE_BY_ID } from "@/api/role_assigment";
import querystring from "query-string";

const state = {
    list_employee: [],
    employee_by_id: [],
};

const mutations = {
    SET_LIST_EMPLOYEE: (state, payload) => {
        for (let x = 0; x < payload.length; x++) {
            payload[x].fullname = `${payload[x].firstName} ${payload[x].lastName} / ${payload[x].username}`
        }
        state.list_employee = payload;
    },
    SET_EMPLOYEE_BY_ID: (state, payload) => {
        state.employee_by_id = payload;
    },
};

const actions = {
    GET_LIST_EMPLOYEE: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_EMPLOYEE(params);
        const data = resp.data.data;
        commit("SET_LIST_EMPLOYEE", data);
    },

    GET_EMPLOYEE_BY_ID: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_EMPLOYEE_BY_ID(params);
        let data = resp.data.data;
        // console.log("emp by id", data);

        const filteredData = data.filter((item, index, array) => {
            const sameAppAndRole = array.filter(el => el.app_name === item.app_name && el.role_name === item.role_name);
            if (sameAppAndRole.length > 1) {
                const sameAppRoleAssignBy = sameAppAndRole.filter(el => el.assignBy === item.assignBy);
                if (sameAppRoleAssignBy.length > 1) {
                    return sameAppRoleAssignBy.indexOf(item) === 0; 
                }
                return item.assignBy !== "Admin Keycloak";
            }
            return true;
        });
        // console.log("filtered emp by id", filteredData);
        commit("SET_EMPLOYEE_BY_ID", filteredData);
    },

    CREATE_DATA: async (_, payload) => {
        return await ADD_EMPLOYEE(payload);
    },
    DELETE_ROLE_USER: async (_, { clientId, payload }) => {
        return await DELETE_USER_ROLE(clientId, payload);
    },
};

const getters = {
    listEmployee: (state) => state.list_employee,
    EmployeeById: (state) => state.employee_by_id,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
